export default class ErrorAppInitUndefinedError extends Error {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(...params: any) {
    super(...params);

    this.name = 'ErrorAppInitUndefinedError';
    this.message = this.message || 'Undefined error';
  }
}
